export const DEFAULT_WHEEL_IDS_BY_LOCALE: Record<Locale, string> = {
  en: '000000000000000000001000',
  ru: '000000000000000000002000',
} as const;

export const DEFAULT_WHEEL_LOCALE: Locale = 'en';
